module.exports = __webpack_public_path__ + "media/goforajourney/img/passeig-gracia-b43d403b166293c9d714cb754f9c4cf1.jpeg";